//// /system/js/plugins/notyf-setup.js
//(function (win) {
//    if (!win) return;

//    var doc = win.document;
//    var notyf = null;

//    function onReady(cb) {
//        if (doc.readyState === 'loading' || !doc.body) {
//            doc.addEventListener('DOMContentLoaded', function once() {
//                doc.removeEventListener('DOMContentLoaded', once);
//                cb();
//            });
//        } else cb();
//    }

//    // Map old Toastr positionClass -> Notyf {x,y}
//    function mapPosition(positionClass) {
//        var pos = (positionClass || '').toLowerCase();
//        var y = pos.indexOf('bottom') !== -1 ? 'bottom' : 'top';
//        var x = 'right';
//        if (pos.indexOf('left') !== -1) x = 'left';
//        else if (pos.indexOf('center') !== -1) x = 'center';
//        return { x: x, y: y };
//    }

//    // Create Notyf with our Toastr-like types & defaults
//    function ensureNotyf() {
//        if (notyf) return notyf;
//        notyf = new win.Notyf({
//            duration: 3000,                 // default Toastr-ish timeout
//            ripple: false,                  // Toastr look has no ripple
//            dismissible: false,
//            position: { x: 'right', y: 'top' },
//            types: [
//                // Success & error are built-in types; we give them our classes
//                { type: 'success', className: 'toast toast-success', icon: false, background: '#51a351' },
//                { type: 'error', className: 'toast toast-error', icon: false, background: '#bd362f', dismissible: false },

//                // Toastr has warning & info � create matching Notyf custom types
//                { type: 'warning', className: 'toast toast-warning', icon: false, background: '#f89406' },
//                { type: 'info', className: 'toast toast-info', icon: false, background: '#2f96b4' }
//            ]
//        });
//        return notyf;
//    }

//    function show(kind, message, title, opts) {
//        var o = opts || {};
//        var text = (title ? (String(title).trim() + (message ? ' � ' : '')) : '') + (message || '');

//        // Allow per-call overrides for timeout/position/closeButton like Toastr
//        var payload = {
//            message: text,
//            duration: (o.timeOut != null ? o.timeOut : undefined),
//            dismissible: !!(o.closeButton || o.dismissible),
//            position: o.positionClass ? mapPosition(o.positionClass) : undefined
//        };

//        var api = ensureNotyf();
//        if (kind === 'success' || kind === 'error') api[kind](payload);
//        else api.open(Object.assign({ type: kind }, payload));
//    }

//    // Export simple helpers so replacement is a trivial rename
//    win.notifySuccess = function (msg, title, opts) { onReady(function () { show('success', msg, title, opts); }); };
//    win.notifyWarning = function (msg, title, opts) { onReady(function () { show('warning', msg, title, opts); }); };
//    win.notifyError = function (msg, title, opts) { onReady(function () { show('error', msg, title, opts); }); };
//    win.notifyInfo = function (msg, title, opts) { onReady(function () { show('info', msg, title, opts); }); };

//})(window);


(function (win) {
    if (!win) return;
    var doc = win.document;

    var DEFAULTS = {
        timeOut: 3000,
        extendedTimeOut: 1000, // delay after mouse leaves (Toastr-like)
        positionClass: 'toast-top-right'
    };

    function onReady(cb) {
        if (doc.readyState === 'loading' || !doc.body) {
            doc.addEventListener('DOMContentLoaded', function once() {
                doc.removeEventListener('DOMContentLoaded', once);
                cb();
            });
        } else cb();
    }

    function mapPosition(positionClass) {
        var pos = (positionClass || DEFAULTS.positionClass).toLowerCase();
        var y = pos.indexOf('bottom') !== -1 ? 'bottom' : 'top';
        var x = 'right';
        if (pos.indexOf('left') !== -1) x = 'left';
        else if (pos.indexOf('center') !== -1) x = 'center';
        return { x: x, y: y };
    }

    function attachHoverPause(el, notif, opts) {
        var ext = (opts.extendedTimeOut != null) ? opts.extendedTimeOut : DEFAULTS.extendedTimeOut;
        var remaining = (opts.timeOut != null) ? opts.timeOut : DEFAULTS.timeOut;
        var start = Date.now();
        var timer = null;

        function clear() { if (timer) { clearTimeout(timer); timer = null; } }
        function dismiss() { try { win.notyf.dismiss(notif); } catch (e) { } }
        function startTimer(ms) {
            clear();
            if (ms > 0) {
                start = Date.now();
                timer = setTimeout(dismiss, ms);
            }
        }

        startTimer(remaining);

        el.addEventListener('mouseenter', function () {
            remaining -= (Date.now() - start);
            if (remaining < 0) remaining = 0;
            clear();
        });

        el.addEventListener('mouseleave', function () {
            startTimer(ext != null ? ext : remaining);
        });

        if (notif && typeof notif.on === 'function') {
            notif.on('dismiss', function () { clear(); });
        }
    }

    function latestToastEl() {
        var nodes = doc.querySelectorAll('.notyf .notyf__toast');
        return nodes[nodes.length - 1] || null;
    }

    // Normalize string/object argument, add our extras (position, dismissible)
    function asOptions(kind, msgOrOpts, more) {
        if (typeof msgOrOpts === 'string') {
            return Object.assign({
                type: kind,
                message: msgOrOpts
            }, more || {});
        }
        var o = Object.assign({}, msgOrOpts || {}, more || {});
        o.type = o.type || kind;
        return o;
    }

    onReady(function () {
        // 1) Create a real Notyf instance and expose it globally (docs-friendly)
        if (!win.notyf) {
            win.notyf = new win.Notyf({
                duration: DEFAULTS.timeOut,
                ripple: false,
                dismissible: false,
                position: mapPosition(DEFAULTS.positionClass),
                types: [
                    { type: 'warning', className: 'toast toast-warning', icon: false, background: '#f89406' },
                    { type: 'info', className: 'toast toast-info', icon: false, background: '#2f96b4' },
                    { type: 'success', className: 'toast toast-success', icon: false, background: '#51a351' },
                    { type: 'error', className: 'toast toast-error', icon: false, background: '#bd362f' }
                ]
            });
        }

        // 2) Patch instance methods so ALL usages (docs-style or aliases) get pause-on-hover
        var n = win.notyf;

        function wrap(methodName, kind) {
            var original = n[methodName].bind(n);
            n[methodName] = function (arg) {
                // Accept string or object; map Toastr-like extras
                var o = (kind ? asOptions(kind, arg) : (typeof arg === 'string' ? { message: arg } : Object.assign({}, arg)));
                var position = o.position || (o.positionClass ? mapPosition(o.positionClass) : undefined);
                var dismissible = !!(o.closeButton || o.dismissible);

                // We manage timing ourselves to support hover-pause
                var payload = Object.assign({}, o, { duration: 0, position: position, dismissible: dismissible });

                // success/error accept string OR object; open requires object with type
                var notif = original(payload);

                // Attach hover pause to the latest toast element
                var el = latestToastEl();
                if (el) attachHoverPause(el, notif, {
                    timeOut: (o.timeOut != null ? o.timeOut : DEFAULTS.timeOut),
                    extendedTimeOut: (o.extendedTimeOut != null ? o.extendedTimeOut : DEFAULTS.extendedTimeOut)
                });

                return notif;
            };
        }

        wrap('success', 'success');
        wrap('error', 'error');
        // open() handles custom types (warning/info)
        wrap('open', null);

        // Convenience helpers so devs can call notyf.warning/info like success/error
        n.warning = function (msgOrOpts) { return n.open(asOptions('warning', msgOrOpts)); };
        n.info = function (msgOrOpts) { return n.open(asOptions('info', msgOrOpts)); };

        // 3) Keep your existing replacements working (aliases to the instance)
        win.notifySuccess = function (msg, title, opts) {
            var text = (title ? (String(title).trim() + (msg ? ' � ' : '')) : '') + (msg || '');
            return n.success(Object.assign({ message: text }, opts || {}));
        };
        win.notifyWarning = function (msg, title, opts) {
            var text = (title ? (String(title).trim() + (msg ? ' � ' : '')) : '') + (msg || '');
            return n.warning(Object.assign({ message: text }, opts || {}));
        };
        win.notifyError = function (msg, title, opts) {
            var text = (title ? (String(title).trim() + (msg ? ' � ' : '')) : '') + (msg || '');
            return n.error(Object.assign({ message: text }, opts || {}));
        };
        win.notifyInfo = function (msg, title, opts) {
            var text = (title ? (String(title).trim() + (msg ? ' � ' : '')) : '') + (msg || '');
            return n.info(Object.assign({ message: text }, opts || {}));
        };
    });
})(window);
